export function getComprobanteFile(values: Record<string, unknown>) {
  const comprobante = values.comprobante as
    | { file?: { originFileObj?: File } | File }
    | undefined;
  const file = comprobante?.file;
  if (file && typeof file === "object" && "originFileObj" in file) {
    return file.originFileObj ?? null;
  }
  return (file as File | undefined) ?? null;
}
